import { CalendarConnectionStatusDtoStatus, useIsCalendarConnected } from '@/api/generated';

const useCalendarConnectionStatus = () => {
  const { data: response, error: calendarConnectionError } = useIsCalendarConnected();

  if (calendarConnectionError) {
    return CalendarConnectionStatusDtoStatus.CONNECTED;
  }

  return response?.items?.[0]?.status;
};

export default useCalendarConnectionStatus;
